import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useDeactivateClass } from '@/features/classes/hooks';

/**
 * `DELETE /classes/:id` is a soft deactivation with no reactivation
 * endpoint in the current backend - the confirmation copy says so
 * accurately rather than implying a reversible or hard delete.
 */
export function DeactivateClassButton({ classId }: { readonly classId: string }): JSX.Element {
  const deactivate = useDeactivateClass();
  const navigate = useNavigate();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button type="button" variant="destructive" size="sm" disabled={deactivate.isPending}>
          Nonaktifkan Kelas
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Nonaktifkan kelas ini?</AlertDialogTitle>
          <AlertDialogDescription>
            Kelas akan dinonaktifkan dan tidak lagi muncul dalam daftar aktif. Riwayat penugasan
            guru dan pendaftaran santri tetap tersimpan. Tindakan ini tidak dapat dibatalkan dari
            dalam aplikasi.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Batal</AlertDialogCancel>
          <AlertDialogAction
            disabled={deactivate.isPending}
            onClick={() => {
              deactivate.mutate(classId, {
                onSuccess: () => {
                  void navigate('/classes');
                },
              });
            }}
          >
            Nonaktifkan
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
